// extracted by mini-css-extract-plugin
module.exports = {"connectionGroupTitle":"_24mA0Sgw","connectionGroup":"_1eit-dn6"};